export const CLEANING_AUDIT = "Cleaning Audit";
export const EDUCATION_TOOLBOX = "Employee Connect";
export const FACILITY_MANAGEMENT = "Facility Management";
export const PERIODICAL = "Work Scheduler";
export const LAUNDRY_AUDIT = "Laundry Audit";
export const FACILITY_PORTAL = "Facility Portal";
export const CLEANING_EXC = "Cleaning Excellence";
export const COMMUNICATION = "Communication"
